import { AccountProvider, Client } from '@collinsonx/constants/enums';

const { Mastercard_MCAE } = Client;

export const FAQLink = (
  accountProvider?: string,
  locale?: string,
  membershipType?: string,
  isFastTrackEnabled?: boolean
) => {
  const faqLinkLK = `https://portal.loungekey.com/${locale}/elo/faq/`;
  const faqLinkPP = `https://memberhelp.prioritypass.com/${locale}/support/home`;
  const faqLinkMCAE = `https://airport.mastercard.com/${locale}/faq`;
  const fastTrackFaqLink = `https://memberhelp.prioritypass.com/${locale}/support/fast-track`;

  if (isFastTrackEnabled) return fastTrackFaqLink;
  if (membershipType === Mastercard_MCAE) return faqLinkMCAE;
  if (accountProvider === AccountProvider.LK) return faqLinkLK;
  if (
    accountProvider === AccountProvider.PP ||
    accountProvider === AccountProvider.PP_PREFERRED
  )
    return faqLinkPP;

  return '';
};
